import './MediaLibrary.scss';
import { observer } from 'mobx-react-lite';
import { Breadcrumb } from './Breadcrumb/Breadcrumb';
import { FileCard } from './FileCard/FileCard';
import { FolderCard } from './FolderCard/FolderCard';
import { useStores } from 'index';
import { useEffect } from 'react';
import { Node } from '../../../types/admin/nodes';
import { Typography } from '@mui/material';
import { SearchBar } from './SearchBar/SearchBar';

type Props = {
  onNodesSelected: (nodes: Node[]) => void;
};

export const FileManager = observer(({ onNodesSelected }: Props) => {
  const { currentFiles, currentDirectories, selectedNodes } = useStores().mediaLibraryStore;

  useEffect(() => {
    onNodesSelected(selectedNodes);
  }, [selectedNodes, onNodesSelected]);

  const hasFolders = currentDirectories.length > 0;
  const hasFiles = currentFiles.length > 0;

  return (
    <div className='file-manager'>
      <SearchBar />
      <Breadcrumb />

      {hasFolders && (
        <div className='file-manager__section'>
          <Typography variant='subtitle2' sx={{ fontWeight: 600, color: 'text.secondary', mb: 1 }}>
            Folders
          </Typography>
          <div className='file-manager__grid'>
            {currentDirectories.map((folder) => (
              <FolderCard key={folder.id} folder={folder} />
            ))}
          </div>
        </div>
      )}

      {hasFiles && (
        <div className='file-manager__section'>
          <Typography variant='subtitle2' sx={{ fontWeight: 600, color: 'text.secondary', mb: 1 }}>
            Files
          </Typography>
          <div className='file-manager__grid'>
            {currentFiles.map((file) => (
              <FileCard key={file.id} file={file} />
            ))}
          </div>
        </div>
      )}

      {!hasFolders && !hasFiles && (
        <div className='file-manager__empty'>
          <Typography variant='body2' color='text.secondary' sx={{ textAlign: 'center', py: 4 }}>
            This folder is empty
          </Typography>
        </div>
      )}
    </div>
  );
});
